import { useSyncExternalStore } from 'react';
import {
  getCompanyScope,
  subscribeCompanyScope,
  type CompanyScope,
} from '@/services/companyScope';

/**
 * Empresa que backoffice está gestionando en `/company/*` (null si el usuario
 * es el admin de su propia empresa). Ver `services/companyScope`.
 */
export function useCompanyScope(): CompanyScope | null {
  return useSyncExternalStore(subscribeCompanyScope, getCompanyScope, () => null);
}
